export function setSwitcherValue(name, value) {
    return (dispatch) => {
        dispatch({
            type: 'SET_SWITCHER_VALUE',
            name,
            value
        });
    };
}



// WEBPACK FOOTER //
// ./src/client/actions/switchers.js